/**
 * VoiceField (spec 3) — a text Field with an inline mic, so any field can be filled by voice.
 * The transcript is APPENDED to the current value (space-joined), so a user can dictate in parts
 * or mix typing and talking. Wraps the design-system Field + the shared MicButton (edge STT,
 * mobile invariant 5). NEVER imports @smartbox/*.
 */
import { View, StyleSheet } from 'react-native';
import { Field, type FieldProps } from '../ui';
import { MicButton } from './MicButton';
import { theme } from '../../theme';

type VoiceFieldProps = FieldProps & {
  /** Current field value (controlled). */
  value: string;
  onChangeText: (text: string) => void;
  /** Accessibility label for the mic (defaults from the field label). */
  micAccessibilityLabel?: string;
  /** Disable the mic (e.g. while a mutation is in flight). */
  micDisabled?: boolean;
};

export function VoiceField({ value, onChangeText, micAccessibilityLabel, micDisabled, ...fieldProps }: VoiceFieldProps) {
  const appendTranscript = (t: string) => {
    const piece = t.trim();
    if (!piece) return;
    onChangeText(value && value.trim() ? `${value.trim()} ${piece}` : piece);
  };

  return (
    <View style={styles.row}>
      <View style={styles.field}>
        <Field value={value} onChangeText={onChangeText} {...fieldProps} />
      </View>
      <MicButton
        onTranscribe={appendTranscript}
        disabled={micDisabled}
        size="md"
        label=""
        accessibilityLabel={micAccessibilityLabel ?? `Dictate ${fieldProps.label ?? 'field'}`}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    gap: theme.spacing.sm,
  },
  field: {
    flex: 1,
  },
});
